/**
 * @file JSON格式数据处理相关API
 * @author lizhuo(lizhuo@bytedance.com)
 */

/**
 * 将JSON数据解析为JS对象，可捕获异常
 * @param {string} json JSON形式的字符串，可以不符合json规则或undefined
 * @returns {object} obj 经JSON.parse()后的结果，若无法解析，则为undefined
 */
export function catchableParse (json) {
  try {
    return JSON.parse(json)
  } catch (e) {}
}
export function uniqArray (array) {
  let resultArray = []
  if (array && array.length) {
    array.forEach(function (item) {
      let value = $.trim(item)
      if (value.length) {
        resultArray.push(value)
      }
    })
  }
  return resultArray
}

/**
 *
 * @param source
 * @returns {*}
 */
export function deepCopy (source) {
  let str, newobj
  if (typeof source !== 'object') {
    return
  }
  try {
    newobj = source.constructor === Array ? [] : {}
  } catch (e) {
    return
  }
  if (window.JSON) {
    str = JSON.stringify(source)
    newobj = JSON.parse(str)
  } else {
    for (let i in source) {
      newobj[i] = typeof source[i] === 'object' ? this.deepCopy(source[i]) : source[i]
    }
  }
  return newobj
}

export default {
  catchableParse,
  uniqArray,
  deepCopy
}
